import React,{useState} from 'react'
import { useForm } from 'react-hook-form';
import {useParams} from "react-router-dom";





function Resetpassword(){
    const { register, handleSubmit, errors } = useForm();

    let { id } = useParams();
    

    const[loading,setloading] = useState(false);
    const[done,setdone] = useState(false);
    const[status,setstatus] = useState(false);


    const onSubmit = data => {
        //console.log(data)
        setloading(true);

        const senddata = {'password':data.password,'mailtoken':id}

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json','Accept':'application/json' },
            body: JSON.stringify(senddata)
        };
        //console.log(requestOptions);
        fetch('https://api.quiz360.ir/public/api/v1/resetpassword', requestOptions)
            .then(response => response.json())
            .then(data1 =>setdataapi(data1) );
            ////console.log(resp?.data.api_token)
      
            const setdataapi = data1 => {
                setdone(true);
              //console.log(data1)
          if(data1?.data?.data[0]===1){
            setstatus(true)
              
            //console.log('getstatus')
          }
      
          
        
        }
    }

    return(
        <div>
            {!done ? (<form class="text-center" onSubmit={handleSubmit(onSubmit)}>
                <span class="badge badge-secondary">بازنشانی رمز عبور</span>
        <div class="form-group">
        <label for="exampleInputEmail1">رمز عبور جدید</label>
            <input type="password" class="form-control" placeholder="رمز جدید" name="password"  ref={register({required: {value:true,message:"این فیلد الزامی است"},minLength:{value:8,message:"رمز عبور خیلی کوتاه است"}})} />
            <div class="alert-danger">
                {errors?.password?.message}
      </div>
      </div>
      {!loading  ? (<input type="submit" class="btn btn-outline-success" value=" بازنشانی رمز عبور" />):(<div class="text-center">
                
                <div class="spinner-grow text-success" style={{'width': '6rem','height': '6rem'}} role="status">
                  <span class="sr-only">در حال بارگیری</span>
                </div>
                            </div>)}
      </form>):(<div>
          {!status ? (<div class="text-center">
            <div class="alert alert-warning" role="alert">
                خطایی رخ داده لطفا بعدا امتحان کنید
            </div>
                   
          </div>):(<div class="text-center">
            <div class="alert alert-success" role="alert">
                رمز عبور با موفقیت تغییر کرد 
            </div>
          </div>)}
      </div>)}
        </div>
       
    );
}

export default Resetpassword;